// Feed Completeness Banner Styled Components
// Pinned prompt in the Matches feed for users whose onboarding data is
// incomplete — the feed quality they get is directly tied to it.
import styled, { keyframes } from 'styled-components';
import { theme } from '../theme';

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// FeedNavigation is position: fixed at top: 0, so anything else pinned to the
// top of the feed lands underneath it. Its height is the tab row (0.5rem
// padding x2) plus the tab itself (0.25rem padding x2 + 0.875rem text) plus
// the 1px bottom border — ~42px. Rounded up to 44px, with a gap below it.
export const FEED_NAV_HEIGHT = '44px';

export const BannerContainer = styled.div`
  position: absolute;
  top: calc(${FEED_NAV_HEIGHT} + ${theme.spacing.xs});
  left: 0;
  right: 0;
  z-index: 60;
  margin: ${theme.spacing.sm};
  padding: ${theme.spacing.md};
  border-radius: ${theme.borderRadius.lg};
  background: rgba(20, 20, 24, 0.82);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
  color: #fff;
  animation: ${slideDown} 0.35s ease;

  @media (max-width: ${theme.breakpoints.mobile}) {
    margin: ${theme.spacing.xs};
    padding: ${theme.spacing.sm} ${theme.spacing.md};
  }
`;

export const BannerTopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
`;

export const BannerTitle = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.3;
`;

export const BannerSubtitle = styled.div`
  margin-top: 2px;
  font-size: 0.78rem;
  opacity: 0.75;
  line-height: 1.4;
`;

export const BannerDismiss = styled.button`
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }
`;

export const ProgressTrack = styled.div`
  margin: ${theme.spacing.sm} 0;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${props => Math.max(4, Math.min(100, props.$percent))}%;
  border-radius: 3px;
  background: linear-gradient(90deg, ${theme.colors.primary}, ${theme.colors.secondary});
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const MissingList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
  margin-bottom: ${theme.spacing.sm};
`;

export const MissingRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.sm};
  width: 100%;
  padding: ${theme.spacing.xs} ${theme.spacing.sm};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  text-align: left;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const MissingLabel = styled.span`
  font-size: 0.82rem;
  font-weight: 600;
`;

export const MissingWhy = styled.span`
  display: block;
  font-size: 0.72rem;
  font-weight: 400;
  opacity: 0.7;
  margin-top: 1px;
`;

export const MissingGain = styled.span`
  flex-shrink: 0;
  font-size: 0.72rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  white-space: nowrap;
`;
